var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.highlightingLabel && _vm.visible)?_c('div',{staticClass:"highlighting-label",style:(_vm.labelStyle)},[_vm._v("\n  "+_vm._s(_vm.highlightingLabel.name)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }